/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { useState } from 'react';

/* Import configuration */
import {
    DEFAULT_TIME_SERIES_GROUP,
    EXAMPLE_INTERVAL_VALUE_REQUEST,
} from '@/config/eeCheckConfig';

/* Import hooks */
import { useDemoSensorDeviceSelection } from '@/hooks/useDemoSensorDeviceSelection';

export function useIntervalValueDemo(sensorCatalogVersion: number) {
    const selection = useDemoSensorDeviceSelection(DEFAULT_TIME_SERIES_GROUP, sensorCatalogVersion);
    const [intervalValueTargets, setIntervalValueTargets] = useState<string[]>([]);
    const [intervalValueFrom, setIntervalValueFrom] = useState(EXAMPLE_INTERVAL_VALUE_REQUEST.from);
    const [intervalValueTo, setIntervalValueTo] = useState(EXAMPLE_INTERVAL_VALUE_REQUEST.to);
    const [intervalValueInterval, setIntervalValueInterval] = useState(EXAMPLE_INTERVAL_VALUE_REQUEST.interval ?? '1year');
    const intervalValueRequest = {
        from: intervalValueFrom,
        interval: intervalValueInterval.trim() || undefined,
        to: intervalValueTo,
        urn: intervalValueTargets.join(','),
    };

    return {
        ...selection,
        intervalValueFrom,
        intervalValueInterval,
        intervalValueRequest,
        intervalValueTarget: selection.selectedSensorTarget,
        intervalValueTargets,
        intervalValueTo,
        setIntervalValueFrom,
        setIntervalValueInterval,
        setIntervalValueTargets,
        setIntervalValueTo,
    };
}
